import React from 'react';
import { CONSTANT } from '../constants/index';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  footer: {
    padding: '100px 24px',
    '@media (max-width: 1260px)': {
      fontSize: 10
    }
  }
}));

const HeaderContent: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.footer}>
      <h3>
        Copyright ©{new Date().getFullYear()} 北京晟晗知识产权代理有限公司 
        <a href='https://beian.miit.gov.cn/#/Integrated/index' target='blank'>京ICP备2025103178号-1</a>
      </h3>
      <h3>地址：北京市昌平区北清路1号院珠江摩尔国际大厦5号楼2单元1110</h3>
      <h3>电话：{CONSTANT.tel}</h3>
      <h3>电话：{CONSTANT.phone}</h3>
    </div>
  );
};

export default HeaderContent;